module.exports = __webpack_public_path__ + "img/AT0000093710018.22c9f5f3.png";